import {
    faBadgeCheck,
    faCalendarLines,
    faClock,
    faCoins,
    faFire,
    faMemoPad,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IssueMetricType } from 'shared/issue_metrics/types';
import { tokens } from 'styles/tokens';
import { Lookup } from 'utils/types';

export type MetricColorConfig = {
    background: string;
    icon: string;
};

export const METRIC_COLORS: Lookup<IssueMetricType, MetricColorConfig | undefined> = {
    new: {
        background: tokens.metric.newBackground,
        icon: tokens.metric.newIcon,
    },
    open: {
        background: tokens.metric.openBackground,
        icon: tokens.metric.openIcon,
    },
    draft: {
        background: tokens.metric.draftBackground,
        icon: tokens.metric.draftIcon,
    },
    resolved: {
        background: tokens.metric.resolvedBackground,
        icon: tokens.metric.resolvedIcon,
    },
    days: {
        background: tokens.metric.daysBackground,
        icon: tokens.metric.daysIcon,
    },
    downtime: {
        background: tokens.metric.downtimeBackground,
        icon: tokens.metric.downtimeIcon,
    },
    savings: {
        background: tokens.metric.savingsBackground,
        icon: tokens.metric.savingsIcon,
    },
    severe: {
        background: tokens.metric.severeBackground,
        icon: tokens.metric.severeIcon,
    },
    'issue-addressed': {
        background: tokens.metric.resolvedBackground,
        icon: tokens.metric.resolvedIcon,
    },
};

export const METRIC_ICONS: Lookup<IssueMetricType, JSX.Element> = {
    new: <FontAwesomeIcon icon={faMemoPad} size="sm" />,
    open: <FontAwesomeIcon icon={faMemoPad} size="sm" />,
    draft: <FontAwesomeIcon icon={faMemoPad} size="sm" />,
    resolved: <FontAwesomeIcon icon={faBadgeCheck} size="sm" />,
    severe: <FontAwesomeIcon icon={faFire} size="sm" />,
    days: <FontAwesomeIcon icon={faCalendarLines} size="sm" />,
    downtime: <FontAwesomeIcon icon={faClock} size="sm" />,
    savings: <FontAwesomeIcon icon={faCoins} size="sm" />,
    'issue-addressed': <FontAwesomeIcon icon={faBadgeCheck} size="sm" />,
};

export function MetricIcon({ type }: { type: IssueMetricType }) {
    return METRIC_ICONS[type];
}
